import Vue from 'vue'
import Message from 'element-ui/packages/message'
import 'element-ui/packages/theme-chalk/src/message.scss'

Vue.prototype.$message = Message
